<template>
    <v-layout column style="gap:4px" v-if="shows">
        <v-btn v-bind="{ loading, outlined: disabled }" color="primary" @click="undo">
            <span>{{ disabled ? "취소완료" : "취소하기" }}</span>
        </v-btn>
    </v-layout>
    <span v-else> - </span>
</template>

<script>
import api from "@/api";
import { initUserExchangeBulk } from "@/assets/lib";

import ExchangeGifts from "@/components/client/exchange/exchange-gifts.vue";
import GiftInfo from "./gift/gift-info.vue";

export default {
    components: {
        ExchangeGifts,
        GiftInfo,
    },
    props: {
        /** @type {import('vue/types/umd').PropType<import('@/assets/lib').UserExchangeBulk>} */
        value: { type: Object, default: initUserExchangeBulk },
    },
    data: () => ({
        /** @type {import('@/assets/lib').UserExchangeBulk} */
        form: initUserExchangeBulk(),

        loading: false,
    }),
    computed: {
        shows() {
            return !this.form.cashed && !this.form.gifted;
        },
        disabled() {
            return this.form.exchanges_toCash.length < 1;
        },
    },
    methods: {
        sync() {
            this.form = initUserExchangeBulk(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        async undo() {
            let go = await this.$confirm("해당 교환을 취소하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.undo.postExec({ _id: this.form._id });
                this.form = initUserExchangeBulk(bulk);

                let items_success = this.form.exchanges.filter((item) => item.done && item.undone);
                let items_failure = this.form.exchanges.filter((item) => item.done && !item.undone);

                let message = "";
                if (0 < items_failure.length) {
                    let totalCount = this.form.exchanges.length;
                    let successCount = items_success.length;

                    message = `${totalCount.format()}건 중 ${successCount.format()}건의 교환을 취소하는데 성공하였습니다.`;
                } else {
                    message = `해당 교환을 취소하였습니다.`;
                }

                alert(message);
            } finally {
                this.loading = false;
            }
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
